export default __webpack_public_path__ + "static/media/Flametemper Arrows.2043dfe3.jpg";